export default __webpack_public_path__ + "static/media/snow.63c53bb9.png";